import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import { DomainDesignation } from "@constants";
import { asRoundedPercentage } from "@components/Filters/number.js";
import DomainRow from "./Program.ScoreCard.DomainRow.vue";
import DomainIndicatorRow from "./Program.ScoreCard.DomainIndicatorRow.vue";
export default {
  components: {
    DomainRow,
    DomainIndicatorRow
  },
  filters: {
    asRoundedPercentage
  },
  data() {
    return {};
  },
  computed: {
    program() {
      return this.$store.getters.program;
    },
    entityProgram() {
      return this.$store.getters.programCategorySummary;
    },
    domains() {
      return this.$store.state.domains;
    },
    overall() {
      return this.$store.state.overallDomain;
    },
    overallDesignation() {
      return DomainDesignation.getDesignation(this.scoredFacts, this.overall);
    },
    overallPointsEarned() {
      let earned = 0;
      this.scoredFacts.forEach(x => earned += x.IndicatorPointsEarned);
      return earned;
    },
    overallPointsPossible() {
      let possible = 0;
      for (let i = 0; i < this.scoredFacts.length; i++) {
        let pointsPossible = this.overall.Indicators.find(x => this.scoredFacts[i].DomainIndicatorId === x.DomainIndicatorId);
        possible += pointsPossible ? pointsPossible.PointsPossible : 0;
      }
      return possible;
    },
    scoredFacts() {
      return DomainDesignation.getScoredFacts(this.entityProgram.Facts);
    }
  },
  methods: {
    showVideoModal(e) {
      e.preventDefault();
      this.$store.dispatch("openVideoModal", true);
    }
  }
};